import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import AutoComplete from 'material-ui/AutoComplete';
import styled from 'styled-components';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import { localize } from 'react-localize-redux';
import { translate } from 'react-i18next';

import { primary1Color } from '../theme';
import i18n from '../translations/i18n';

const propTypes = {
  t: PropTypes.func,
  onConfirm: PropTypes.any,
  endUsers: PropTypes.any,
  currentOwner: PropTypes.any,
  packetbox: PropTypes.any,
  packetboxKeys: PropTypes.any,
  onCancel: PropTypes.any,
  open: PropTypes.any,
};

const defaultProps = {};

/*
  Styled components
 */
const Subtitle = styled.div`
  text-align: center;
  line-height: 30px;
  color: white;
  text-transform: uppercase;
  background-color: ${primary1Color};
  font-weight: bold;
  font-size: 13px;
`;

const UserInfo = styled.p`
  line-height: 20px;
`;

const Note = styled.p`
  font-size: 11px;
  text-align: center;
`;

class ChangeOwnerDialog extends React.Component {
  state = {
    searchText: '',
    newOwner: null,
  };

  handleUpdateInput = (searchText) => {
    this.setState({
      searchText,
    });
  };

  handleNewRequest = (chosenRequest) => {
    this.setState({
      newOwner: chosenRequest.value,
    });
  };

  confirm = () => {
    this.props.onConfirm(this.state.newOwner);
  };

  render() {
    const { endUsers, currentOwner, packetbox, packetboxKeys } = this.props;
    const newOwner = this.state.newOwner;

    const currentOwnerName = !currentOwner
      ? ''
      : `${currentOwner.full_name} (${currentOwner.username})`;

    const dataSourceConfig = {
      text: 'text',
      value: 'value',
    };

    const dataSource = endUsers
      .filter(enduser => !currentOwner || (enduser.valid && enduser.id !== currentOwner.id))
      .map(endUser => ({
        text: `${endUser.full_name} (${endUser.username})`,
        value: endUser,
      }));

    const actions = [
      <FlatButton label="Cancel" primary onTouchTap={this.props.onCancel} />,
      <FlatButton label="Confirm" primary keyboardFocused onTouchTap={this.confirm} />,
    ];

    let keysTableRows = null;

    if (packetboxKeys) {
      keysTableRows = packetboxKeys.map(key => (
        <TableRow key={key.id}>
          <TableRowColumn>{key.consumer_full_name}</TableRowColumn>
          <TableRowColumn>{key.consumer_username}</TableRowColumn>
          <TableRowColumn>{key.consumer_email}</TableRowColumn>
          <TableRowColumn>{this.props.t(`auth_action_${key.action}`)}</TableRowColumn>
        </TableRow>
      ));
    }

    let title = null;

    if (packetbox) {
      const changeOwnText = this.props.t('change_ownership_of');
      title = `${changeOwnText}: ${packetbox.name}, ${packetbox.street} ${
        packetbox.street_number
      }, ${packetbox.place}`;
    }

    return (
      <div>
        <Dialog
          title={title}
          actions={actions}
          modal={false}
          open={this.props.open}
          onRequestClose={this.handleClose}
          autoScrollBodyContent
          contentStyle={{ width: '80%', maxWidth: 'none' }}
        >
          <div className="row">
            <div className="col-xs-6">
              <div className="box">
                <Subtitle>Current owner</Subtitle>
              </div>
            </div>
            <div className="col-xs-6">
              <div className="box">
                <Subtitle>New owner</Subtitle>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-6">
              <div className="box">
                <TextField
                  hintText={this.props.t('current_owner')}
                  floatingLabelText={this.props.t('current_owner')}
                  defaultValue={currentOwnerName}
                  disabled
                  fullWidth
                />
              </div>
            </div>
            <div className="col-xs-6">
              <div className="box">
                <AutoComplete
                  name="owner_id"
                  openOnFocus
                  filter={AutoComplete.caseInsensitiveFilter}
                  dataSourceConfig={dataSourceConfig}
                  dataSource={dataSource}
                  hintText={this.props.t('new_owner')}
                  floatingLabelText={this.props.t('new_owner')}
                  searchText={this.state.searchText}
                  onUpdateInput={this.handleUpdateInput}
                  onNewRequest={this.handleNewRequest}
                  fullWidth
                  listStyle={{ maxHeight: 200, overflow: 'auto' }}
                />
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-xs-6">
              <div className="box">
                {currentOwner && (
                  <UserInfo>
                    <b>Username:</b> {currentOwner.username} <br />
                    <b>First name:</b> {currentOwner.first_name} <br />
                    <b>Last name:</b> {currentOwner.last_name}
                  </UserInfo>
                )}
                <br />
                <br />
                <Note>{this.props.t('change_ownership_tan_delete')}</Note>
                <Table
                  className="mui-table"
                  fixedHeader={false}
                  style={{ width: 'auto', tableLayout: 'auto', margin: '0 auto' }}
                >
                  <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                    <TableRow>
                      <TableHeaderColumn colSpan="4" style={{ textAlign: 'center' }}>
                        {this.props.t('authorizations')}
                      </TableHeaderColumn>
                    </TableRow>
                    <TableRow>
                      <TableHeaderColumn>{this.props.t('name')}</TableHeaderColumn>
                      <TableHeaderColumn>{this.props.t('username')}</TableHeaderColumn>
                      <TableHeaderColumn>{this.props.t('email')}</TableHeaderColumn>
                      <TableHeaderColumn>{this.props.t('action')}</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox={false}>{keysTableRows}</TableBody>
                </Table>
              </div>
            </div>
            <div className="col-xs-6">
              <div className="box">
                {newOwner && (
                  <UserInfo>
                    <b>Username:</b> {newOwner.username} <br />
                    <b>First name:</b> {newOwner.first_name} <br />
                    <b>Last name:</b> {newOwner.last_name}
                  </UserInfo>
                )}
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

ChangeOwnerDialog.propTypes = propTypes;
ChangeOwnerDialog.defaultProps = defaultProps;

const extended = translate(['translations'], { i18n })(ChangeOwnerDialog);
export default localize(extended, 'locale');



// WEBPACK FOOTER //
// ./src/components/ChangeOwnerDialog.js